import { Avatar, Box, Text } from '@wix/design-system';
import React, { FC, useMemo } from 'react';

import { IUserAccountItem } from '../../../common/messageCreators';

export const UserAccountItem: FC<IUserAccountItem> = ({ _id, accountName, accountImg, slug }) => {
  const imgProps = useMemo(
    () => ({
      src: accountImg,
    }),
    [accountImg],
  );

  const displayName = accountName || slug;

  return (
    <Box gap="SP2" verticalAlign="middle" dataHook={`account-${_id}`}>
      <Avatar shape="square" name={displayName} imgProps={imgProps} />
      <Box overflow="hidden">
        <Text dataHook="account-name">{displayName}</Text>
      </Box>
    </Box>
  );
};
